import React, { useEffect } from 'react'
import { Route, useLocation, useNavigate } from 'react-router-dom'
import { Wrapper } from '../Components/Utils/roles'

import MainPage from '../Views/Web/Product/MainPage';
import MainCatalogues from '../Views/Web/Product/Catalogues/MainCatalogues';
import MainItems from '../Views/Web/Product/Items/MainItems';

import CatalogueIndex from '../Views/Web/Product/Catalogues';
import CreateCatalogues from '../Views/Web/Product/Catalogues/CreateCatalogues';
import EditCatalogues from '../Views/Web/Product/Catalogues/EditCatalogues';
import ViewCatalogues from '../Views/Web/Product/Catalogues/ViewCatalogues';
import ViewItems from '../Views/Web/Product/Items/ViewItems';
import EditItems from '../Views/Web/Product/Items/EditItems';
import CreateItems from '../Views/Web/Product/Items/CreateItems';
import ItemIndex from '../Views/Web/Product/Items';
const ProductRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      location.pathname === "/procurement" ||
      location.pathname === "/procurement/") {
      navigate("/page-not-found")
    }
  }, [location])
  return (
    <Route path="products" element={<MainPage />}>
      <Route path="catalogues" element={<MainCatalogues />}>
        <Route index element={<Wrapper permissionKey={"catalogue_view"} Component={CatalogueIndex} />} />
        <Route path="create" element={<Wrapper permissionKey={"catalogue_create"} Component={CreateCatalogues} />} />
        <Route path='edit/:catalogueEditId' element={<Wrapper permissionKey={"catalogue_edit"} Component={EditCatalogues} />} />
        <Route path='view/:catalogueViewId' element={<Wrapper permissionKey={"catalogue_view"} Component={ViewCatalogues} />} />
      </Route>
      <Route path="items" element={<MainItems />}>
        <Route index element={<Wrapper permissionKey={"items_view"} Component={ItemIndex} />} />
        <Route path="create" element={<Wrapper permissionKey={"items_create"} Component={CreateItems} />} />
        <Route path='edit/:itemsEditId' element={<Wrapper permissionKey={"items_edit"} Component={EditItems} />} />
        <Route path='view/:itemsViewId' element={<Wrapper permissionKey={"items_view"} Component={ViewItems} />} />
      </Route>
    </Route>
  )
}
export default ProductRoutes